import { render, staticRenderFns } from "./DisconnectPrivateConnectModal.vue?vue&type=template&id=0c355696&"
import script from "./DisconnectPrivateConnectModal.vue?vue&type=script&lang=js&"
export * from "./DisconnectPrivateConnectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c355696')) {
      api.createRecord('0c355696', component.options)
    } else {
      api.reload('0c355696', component.options)
    }
    module.hot.accept("./DisconnectPrivateConnectModal.vue?vue&type=template&id=0c355696&", function () {
      api.rerender('0c355696', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DisconnectPrivateConnectModal.vue"
export default component.exports